Revolution.Module.extend({
    NAME: "mde.main", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "myfunction", "runEqualHeight", "getHeightsForOffsets");

        //Example to call an external function
        //var UTILS = Revolution.get("mde._utils");
        //UTILS.equalheight($('.bk-mosaique .js-equal-height'));

        //prevent pace.js loading bug
        setTimeout(function () {
            $('body').removeClass('pace-running').addClass('pace-done');
        }, 2000);

        // system messages
        $('#block-system-messages').fadeToggle("slow");
        setTimeout(function () {
            $('#block-system-messages').fadeToggle("slow");
        }, 5000);

        this.InitHeaderWhite();

        // Lazy Load
        window.bLazy = new Blazy({selector: '.lazy', loadInvisible: true});

        // Object-fit pollyfill
        objectFitImages();

        this.setScrollToTopVisibility();
        $('.btn-back-to-top').click(this.goToTopPage);

        // Skip-links : pousse tout le contenu (pas seulement l'en-tête, déjà
        // géré en CSS pur via ~) quand la barre devient visible au focus.
        $('.skip-links a').on('focus', function () {
            $('body').addClass('skiplinks-open');
        }).on('blur', function () {
            $('body').removeClass('skiplinks-open');
        });

        this.initLanguages();
        this.initHeaderAccount();

        this.InitCustomRanges();

        this.InitNativeFullscreen();

        this.popin();

        this.initOrDestroyStickyElems();
    },

    onWindowLoad: function (e) {
        //
    },
    onWindowScroll: function (e) {
        this.setScrollToTopVisibility();
    },
    onWindowResize: function (e) {
        this.InitHeaderWhite();
        this.setScrollToTopVisibility();

        this.initOrDestroyStickyElems();
    },

    InitHeaderWhite: function () {
        if ($(window).width() >= 1024 && !$('.page-content-wrapper').attr('style')) {
            if ($('body.header-white').length) {
                var headerHeight = $('.page-header-wrapper').outerHeight();
                $('.page-content-wrapper').css('margin-top', -headerHeight+'px');

                var newPaddingBanner = parseInt($('.page-content-wrapper').find('.bk-banner').css('padding-top')) + headerHeight;
                $('.page-content-wrapper').find('.bk-banner').css('padding-top', newPaddingBanner+'px');

                var bkBannerHeight = $('.page-content-wrapper').find('.bk-banner').outerHeight();
                $('.page-content-wrapper').find('.bk-banner').css('height', (bkBannerHeight + headerHeight)+'px');
            }
        }
        if ($(window).width() < 1024 && $('.page-content-wrapper').attr('style')) {
            $('.page-content-wrapper').removeAttr('style');
            $('.page-content-wrapper').find('.bk-banner').removeAttr('style');
        }
    },

    goToTopPage: function () {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
        Revolution.get("mde.accessible-function").giveTempFocus($('body'));
    },

    setScrollToTopVisibility: function (e) {
        var $btn = $('.btn-back-to-top');
        var offset = $(window).height();

        if ($(window).scrollTop() > offset) {
            $btn.addClass('visible');
        } else {
            $btn.removeClass('visible');
        }
    },

    initLanguages: function (e) {
        if($('.js-bk-languages').length) {
            $('body').on('click', '.js-btn-languages', function() {
                $(this).next().slideToggle();
            })
        }
    },

    initHeaderAccount: function (e) {
        if($('.js-bk-header-account').length) {
            $('body').on('click', '.js-header-account-btn', function() {
                $(this).next().slideToggle();
            })
        }
    },

    toggleFullScreen: function (el) {
        if( window.innerHeight == screen.height) { // is fullscreen
            document.exitFullscreen()
        } else {
            el.requestFullscreen();
        }
    },

    InitNativeFullscreen: function (e) {
        $('.js-fullscreen').each(_.bind(function (index, elem) {
            $(elem).on('click', _.bind(function(){
                this.toggleFullScreen(elem.parentNode.parentNode)
            }, this));
        }, this))
    },

    InitCustomRanges: function (e) {
        $('.js-simple-range').each(function (index, elem) {
            var slider = $(elem)[0];

            noUiSlider.create(slider, {
                start: 0,
                step: 1,
                tooltips: true,
                range: {
                    'min': parseInt($(elem).attr('data-min')),
                    'max': parseInt($(elem).attr('data-max')),
                },
                format: {
                    from: function ( value ) {
                        return value;
                    },
                    to: function ( value ) {
                        return value + ($(elem).attr('data-suffix') ? $(elem).attr('data-suffix') : '');
                    }
                }
            });
        })
    },
    popin : function() {
        $.extend(true, $.magnificPopup.defaults, {
            tClose: 'Fermer (Esc)', // Alt text on close button
            tLoading: 'Chargement...', // Text that is displayed during loading. Can contain %curr% and %total% keys
            gallery: {
              tPrev: 'Précédent (Flèche gauche)', // Alt text on left arrow
              tNext: 'Suivant (Flèche droite)', // Alt text on right arrow
              tCounter: '%curr% de %total%' // Markup for "1 of 7" counter
            },
            image: {
              tError: '<a href="%url%">l\'image</a> n\'a pas pu être chargée.' // Error message when image could not be loaded
            },
            ajax: {
              tError: '<a href="%url%">Le contenu</a> n\'a pas pu être chargée.' // Error message when ajax request failed
            }
        });

        $('.js-popin').magnificPopup({
            mainClass: 'mfp-fade'
        });
        $('.js-gallery').magnificPopup({
            delegate: 'a',
            type: 'image',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: false,
                preload: [0,1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: '<a href="%url%">L\'image #%curr%</a> n\'a pas pu être chargée.',
                titleSrc: function(item) {
                    return item.el.attr('data-credit');
                }
            },
            callbacks: {
              open: function() {
                var self = this;
                self.wrap.on('click.pinhandler', 'img', function() {
                  self.wrap.toggleClass('mfp-force-scrollbars');
                });
              },
              beforeClose: function() {
                    this.wrap.off('click.pinhandler');
                this.wrap.removeClass('mfp-force-scrollbars');
              }
            },
        });
    },

    initOrDestroyStickyElems : function() {
        var headerBreadcrumbH = $('.page-header-wrapper').outerHeight() + $('.bk-breadcrumb').outerHeight();
        var headerH = $('.page-header-wrapper').outerHeight();

        if ($(".js-bk-summary").length) {
            if ($(window).width() >= 1024) {
                $(".js-bk-summary").stick_in_parent({
                    offset_top: headerBreadcrumbH
                });
            } else {
                $(".js-bk-summary").trigger("sticky_kit:detach");
            }
        }

        var $titleEssence = $('.bk-detail-essence .bk-titles-with-btn');
        if ($titleEssence.length) {
            if ($(window).width() >= 1024) {
                $titleEssence.stick_in_parent({
                    offset_top: headerH
                });
            } else {
                $titleEssence.trigger("sticky_kit:detach");
            }
        }
    }
});
